import { Matrix } from '@awayjs/core';
var BitmapFillStyle = /** @class */ (function () {
    function BitmapFillStyle(material, matrix, repeat, smooth) {
        this.material = material;
        this.matrix = matrix;
        this.repeat = repeat;
        this.smooth = smooth;
    }
    Object.defineProperty(BitmapFillStyle.prototype, "data_type", {
        get: function () {
            return BitmapFillStyle.data_type;
        },
        enumerable: true,
        configurable: true
    });
    BitmapFillStyle.prototype.getUVMatrix = function () {
        if (!this.matrix)
            this.matrix = new Matrix();
        var image = (this.material.getTextureAt(0).getImageAt(0));
        //const image: BitmapImage2D = (<any> this.material).ambientMethod.texture._images[0];
        var projection_width_half;
        var projection_height_half;
        if (!image) {
            console.warn('[BitmapFillStyle] - getUVMatrix - no texture found');
            projection_width_half = 512;
            projection_height_half = 512;
        }
        else {
            projection_width_half = image.width;
            projection_height_half = image.height;
        }
        //	Get and invert the uv transform:
        var a = this.matrix.a;
        var b = this.matrix.b;
        var c = this.matrix.c;
        var d = this.matrix.d;
        var tx = this.matrix.tx;
        var ty = this.matrix.ty;
        var a_inv = d / (a * d - b * c);
        var b_inv = -b / (a * d - b * c);
        var c_inv = -c / (a * d - b * c);
        var d_inv = a / (a * d - b * c);
        var tx_inv = (c * ty - d * tx) / (a * d - b * c);
        var ty_inv = -(a * ty - b * tx) / (a * d - b * c);
        this.matrix.a = a_inv / projection_width_half;
        this.matrix.b = b_inv / projection_height_half;
        this.matrix.c = c_inv / projection_width_half;
        this.matrix.d = d_inv / projection_height_half;
        this.matrix.tx = tx_inv / projection_width_half;
        this.matrix.ty = ty_inv / projection_height_half;
        return this.matrix;
    };
    BitmapFillStyle.data_type = '[graphicsdata BitmapFillStyle]';
    return BitmapFillStyle;
}());
export { BitmapFillStyle };
